<div class="modal-content">
  <!-- Cabeçalho do Modal com título e botão de fechar -->
  <div class="modal-header">
    <h5 class="modal-title">Criar lista</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Fechar"
      (click)="activeModal.dismiss()"
    ></button>
  </div>

  <div class="modal-body p-4">
    <form [formGroup]="createContactListForm" (ngSubmit)="onSubmit()">
      <!-- Campo Nome -->
      <div class="mb-3">
        <label class="form-label">Nome</label>
        <input
          class="form-control"
          placeholder="Digite o nome da lista"
          type="text"
          formControlName="descricaoLista"
          [ngClass]="{
            'is-invalid':
              createContactListForm.controls.descricaoLista.touched &&
              createContactListForm.controls.descricaoLista.errors,
          }"
        />
        <div
          class="invalid-feedback"
          *ngIf="
            createContactListForm.controls.descricaoLista.touched &&
            createContactListForm.controls.descricaoLista.errors
          "
        >
          O nome é obrigatório.
        </div>
      </div>
      <!-- Botão de Enviar -->
      <div class="text-end">
        <button type="submit" class="btn btn-success w-md">Criar</button>
      </div>
    </form>
  </div>
</div>
